import { apiClient } from '@/utils/api-client';

export interface Product {
  id: string;
  name: string;
  code: string;
  type: 'tool' | 'resource';
  premium: boolean;
  active: boolean;
  created: string;
  updated: string;
}

export const productService = {
  async listProducts(params?: {
    type?: 'tool' | 'resource';
    active?: boolean;
  }) {
    const queryParams = new URLSearchParams();
    
    if (params?.type) {
      queryParams.append('type', params.type);
    }
    if (params?.active !== undefined) {
      queryParams.append('active', String(params.active));
    }

    const queryString = queryParams.toString();
    const url = queryString ? `/api/admin/products?${queryString}` : '/api/admin/products';
    
    return apiClient.get(url);
  },

  async getProduct(productId: string) {
    return apiClient.get(`/api/admin/products/${productId}`);
  },
};